import { useEffect, useState } from "react";

function Dashboard({ bookId, bookTitle, totalChapters = 11, onOpenChapter, onBack }) {
  const [chapters, setChapters] = useState([]);

  useEffect(() => {
    const data = [];

    for (let i = 1; i <= totalChapters; i++) {
      data.push({ chapter: i });
    }

    setChapters(data);
  }, [totalChapters, bookId]);

  return (
    <div style={styles.container}>
      <button onClick={onBack} style={styles.backBtn}>
        ⬅ Back to Books
      </button>
      <h2 style={styles.title}>
          📖 Book: {bookTitle}
      </h2>

      <div style={styles.grid}>
        {chapters.map((item) => (
          <div key={item.chapter} style={styles.card}>
            <h3>Chapter {item.chapter}</h3>

            <button
              style={styles.btn}
              onClick={() =>
                onOpenChapter(item.chapter)
              }
            >
              ▶ Start Reading
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    background: "#111",
    color: "#fff",
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "15px",
  },
  card: {
    background: "#1c1c1c",
    padding: "15px",
    borderRadius: "10px",
    textAlign: "center",
  },
  btn: {
    marginTop: "10px",
    padding: "8px 12px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
  },
  backBtn: {
    marginBottom: "10px",
    padding: "8px 12px",
    cursor: "pointer",
  },
};

export default Dashboard;